import { Link } from "react-router-dom";

export default function Logo({ dark, to = "/", className = "h-8" }) {
  return (
    <Link to={to} className="flex items-center" data-testid="brand-logo" aria-label="DuruVault">
      <img
        src={dark ? "/logo-white.png" : "/logo-dark.png"}
        alt="DuruVault"
        className={`${className} w-auto select-none`}
        draggable="false"
      />
    </Link>
  );
}
